import { app } from '../app.module'
/**
 * ブランドデータに関するService
 * @param {function} $rootScope
 * @param {Function} Restangular Restangular
 * @param {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function BrandData($rootScope, Restangular, $q) {
  /**
   * getBrands ブランド一覧を取得
   * @param {number} groupId グループID
   * @param {object} getOptions 取得オプション(取得対象月、取得対象業種)
   * @return {Object} ブランド一覧
   */
  function getBrands(groupId) {
    // エンドポイント
    let getUrl = `/brand/getBrands?group_id=${groupId}&is_pro=${$rootScope.isPro}&is_admin=${$rootScope.isAdmin}`

    getUrl += `&flg_facebook=${$rootScope.flgFacebook}&flg_twitter=${$rootScope.flgTwitter}&flg_instagram=${$rootScope.flgInstagram}&flg_youtube=${$rootScope.flgYoutube}&flg_line=${$rootScope.flgLine}&flg_tiktok=${$rootScope.flgTiktok}`

    const deferred = $q.defer()

    // データを取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    return deferred.promise
  }

  /**
   * setBrandData ブランドデータをセット
   * @param  {Object} brands
   * @return {Object} ブランド一覧
   */
  function setBrandData(brands) {
    // ブランドデータ
    const brandsData: {}[] = []

    // Facebookアカウントデータ
    let fbAccountsData: {
      accountId: number
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // Twitterアカウントデータ
    let twAccountsData: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // Instagramアカウントデータ
    let inAccountsData: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // Youtubeアカウントデータ
    let ytAccountsData: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // Lineアカウントデータ
    let lineAccountsData: {
      accountId: number
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // TikTokアカウントデータ
    let ttAccountsData: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
    }[] = []

    // SNSアカウントデータ一時保存用オブジェクト
    let fbAccountObject: {
      accountId: number
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
    }
    let twAccountObject: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
    }
    let inAccountObject: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
    }
    let ytAccountObject: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
      hiddenSubscribersFlg: number
    }
    let lineAccountObject: {
      accountId: number
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
    }
    let ttAccountObject: {
      accountId: number
      accountUsername: string
      accountScreenName: string
      accountPictureUrl: string
      followers: number
      categoryName: string
      subCategoryName: string
      dataFlg: number
    }

    // データが有る場合
    if (brands !== null) {
      brands.forEach((brand) => {
        let totalFollowers = 0
        // 配列を初期化
        fbAccountsData = []
        twAccountsData = []
        inAccountsData = []
        ytAccountsData = []
        lineAccountsData = []
        ttAccountsData = []
        let fbTotalFollowers = 0
        let twTotalFollowers = 0
        let inTotalFollowers = 0
        let ytTotalFollowers = 0
        let lineTotalFollowers = 0
        let ttTotalFollowers = 0

        // Facebookアカウントのデータがある場合
        if (brand.fbAccounts !== null && brand.fbAccounts !== undefined) {
          // 複数データがある場合に分割
          const fbAccounts = brand.fbAccounts.split('\n')
          let isNull = true

          // データをセット
          fbAccounts.forEach((fbAccount: string) => {
            fbAccountObject = JSON.parse(fbAccount)
            if (fbAccountObject.accountId !== null) {
              isNull = false
              fbAccountObject.categoryName = brand.brandCategoryName
              fbAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += fbAccountObject.followers
              fbTotalFollowers += fbAccountObject.followers
              fbAccountsData.push(fbAccountObject)
            }
          })
          if (isNull === true) {
            fbTotalFollowers = -2
          }
        }

        // Twitterアカウントのデータがある場合
        if (brand.twAccounts !== null && brand.twAccounts !== undefined) {
          // 複数データがある場合に分割
          const twAccounts = brand.twAccounts.split('\n')
          let isNull = true

          // データをセット
          twAccounts.forEach((twAccount: string) => {
            twAccountObject = JSON.parse(twAccount)
            if (twAccountObject.accountId !== null) {
              isNull = false
              twAccountObject.categoryName = brand.brandCategoryName
              twAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += twAccountObject.followers
              twTotalFollowers += twAccountObject.followers
              twAccountsData.push(twAccountObject)
            }
          })
          if (isNull === true) {
            twTotalFollowers = -2
          }
        }

        // Instagramアカウントのデータがある場合
        if (brand.inAccounts !== null && brand.inAccounts !== undefined) {
          // 複数データがある場合に分割
          const inAccounts = brand.inAccounts.split('\n')
          let isNull = true

          // データをセット
          inAccounts.forEach((inAccount: string) => {
            inAccountObject = JSON.parse(inAccount)
            if (inAccountObject.accountId !== null) {
              isNull = false
              inAccountObject.categoryName = brand.brandCategoryName
              inAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += inAccountObject.followers
              inTotalFollowers += inAccountObject.followers
              inAccountsData.push(inAccountObject)
            }
          })
          if (isNull === true) {
            inTotalFollowers = -2
          }
        }

        // Youtubeアカウントのデータがある場合
        if (brand.ytAccounts !== null && brand.ytAccounts !== undefined) {
          // 複数データがある場合に分割
          const ytAccounts = brand.ytAccounts.split('\n')
          let isHiddenSubscribers = false as boolean
          let isNull = true

          // データをセット
          ytAccounts.forEach((ytAccount: string) => {
            ytAccountObject = JSON.parse(ytAccount)
            if (ytAccountObject.accountId !== null) {
              isNull = false
              ytAccountObject.categoryName = brand.brandCategoryName
              ytAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += ytAccountObject.followers
              ytTotalFollowers += ytAccountObject.followers
              ytAccountsData.push(ytAccountObject)
              if (ytAccountObject.hiddenSubscribersFlg === 1) {
                isHiddenSubscribers = true
              }
            }
          })

          if (isNull === true) {
            ytTotalFollowers = -2
          } else if (ytTotalFollowers === 0 && isHiddenSubscribers === true) {
            ytTotalFollowers = -1
          }
        }

        // Lineアカウントのデータがある場合
        if (brand.lineAccounts !== null && brand.lineAccounts !== undefined) {
          // 複数データがある場合に分割
          const lineAccounts = brand.lineAccounts.split('\n')
          let isNull = true

          // データをセット
          lineAccounts.forEach((lineAccount: string) => {
            lineAccountObject = JSON.parse(lineAccount)
            if (lineAccountObject.accountId !== null) {
              isNull = false
              lineAccountObject.categoryName = brand.brandCategoryName
              lineAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += lineAccountObject.followers
              lineTotalFollowers += lineAccountObject.followers
              lineAccountsData.push(lineAccountObject)
            }
          })
          if (isNull === true) {
            lineTotalFollowers = -2
          }
        }

        // TikTokアカウントのデータがある場合
        if (brand.ttAccounts !== null && brand.ttAccounts !== undefined) {
          // 複数データがある場合に分割
          const ttAccounts = brand.ttAccounts.split('\n')
          let isNull = true

          // データをセット
          ttAccounts.forEach((ttAccount: string) => {
            ttAccountObject = JSON.parse(ttAccount)
            if (ttAccountObject.accountId !== null) {
              isNull = false
              ttAccountObject.categoryName = brand.brandCategoryName
              ttAccountObject.subCategoryName = brand.brandSubCategoryName
              totalFollowers += ttAccountObject.followers
              ttTotalFollowers += ttAccountObject.followers
              ttAccountsData.push(ttAccountObject)
            }
          })
          if (isNull === true) {
            ttTotalFollowers = -2
          }
        }

        let isEmpty = false

        if (
          !fbAccountsData.length &&
          !twAccountsData.length &&
          !inAccountsData.length &&
          !ytAccountsData.length &&
          !lineAccountsData.length &&
          !ttAccountsData.length
        ) {
          isEmpty = true
        }

        // データをセット
        const brandObject = {
          brandId: brand.brandId,
          brandName: brand.brandName,
          totalFollowers: totalFollowers,
          groupIds: brand.groupIds,
          brandCategoryName: brand.brandCategoryName,
          brandSubCategoryName: brand.brandSubCategoryName,
          fbAccounts: fbAccountsData,
          twAccounts: twAccountsData,
          inAccounts: inAccountsData,
          ytAccounts: ytAccountsData,
          lineAccounts: lineAccountsData,
          ttAccounts: ttAccountsData,
          fbTotalFollowers: fbTotalFollowers,
          twTotalFollowers: twTotalFollowers,
          inTotalFollowers: inTotalFollowers,
          ytTotalFollowers: ytTotalFollowers,
          lineTotalFollowers: lineTotalFollowers,
          ttTotalFollowers: ttTotalFollowers,
          isEmpty,
        }

        // データを追加
        brandsData.push(brandObject)
      })
    }

    return brandsData
  }

  return {
    getBrands: getBrands,
    setBrandData: setBrandData,
  }
}

/**
 * BrandService ブランド関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} BrandData ブランドデータに関するService
 * @return {Object} サービスのオブジェクト
 */
function BrandService(BrandData) {
  return {
    BrandData: BrandData,
  }
}

// サービスを定義
app.factory('BrandService', BrandService).factory('BrandData', BrandData)
